import React, { useState } from 'react';

import { objectId } from '../../apis/local/catalog';
import { useShowNotification } from '../../hooks/useShowNotification';
import { useModal } from '../../hooks/useModal';

import { CartItemsList } from '../shop/CartItemsList';
import { SearchModal } from '../search/SearchModal';

export const OrderFormCart = ({ name, value: initialState, onChange }) => {
    const {
        showModal: showSearchModal,
        handleShow: handleShowSearchModal,
        handleHide: handleHideSearchModal
    } = useModal(false);

    const showNotification = useShowNotification('Orders', 'file-invoice');
    const [items, setItems] = useState(initialState);

    const handleAddItem = (item) => {
        const exists = items.some((current) => current.product.id == item.product.id);
        if (exists) {
            handleChange(
                items.map((current) =>
                    current.product.id == item.product.id
                        ? { ...current, quantity: current.quantity + item.quantity }
                        : current
                )
            );
        } else {
            handleChange([...items, { id: objectId(), ...item }]);
        }
        showNotification(`${item.product.name} added`, 'primary');
    };

    const handleItemChange = (item) => {
        handleChange(items.map((current) => (current.id == item.id ? item : current)));
        showNotification(`${item.product.name} quantity updated`, 'warning');
    };

    const handleItemRemove = (item) => {
        handleChange(items.filter((current) => current.id != item.id));
        showNotification(`${item.product.name} removed`, 'danger');
    };

    const handleChange = (items) => {
        setItems(items);
        onChange(items);
    };

    const CartItemsListFooter = () => {
        return (
            <li className="list-group-item">
                <div className="d-flex align-items-center justify-content-between">
                    <p className="text-muted mb-0">
                        You have {items.length} {items.length == 1 ? 'item' : 'items'}
                    </p>
                    <button
                        type="button"
                        onClick={handleShowSearchModal}
                        className="btn btn-outline-primary">
                        {items.length > 0 ? 'Add more items' : 'Add items'}
                    </button>
                    <SearchModal
                        show={showSearchModal}
                        onHide={handleHideSearchModal}
                        onAddItem={handleAddItem}
                        addItemText="Add to order"
                    />
                </div>
            </li>
        );
    };

    return (
        <CartItemsList
            items={items}
            footer={CartItemsListFooter}
            onItemChange={handleItemChange}
            onItemRemove={handleItemRemove}
        />
    );
};
